import { initDeleteBtn } from '../helpers/helper.js';

const updateVirtualDomBefore = (table) => {
	/*
	 * update cell in the virtual dom 
	 * Works only if given data-form="true" and a data-unique-id="id"
	 * https://examples.bootstrap-table.com/#methods/update-cell-by-unique-id.html#view-source
	 */
	if(table.data('form')){
		table.find('input[data-changed]').each(function(){			
			let value = $(this).val();
			$(this).attr('value', value);			
			$(this).removeAttr('data-changed');

			let rowId = $(this).parents('tr').data('uniqueid');
			let content = $(this).parents('td').html();

			//Search the td name
			let eq = $(this).parents('td')[0].cellIndex;
			let field = table.find('thead').find('th:eq(' + eq + ')').data('field');			

			table.bootstrapTable('updateCellByUniqueId', {
				id: rowId,
				field: field,
				value: content
			});
		});
	}
}

const updateVirtualDomAfter = (table) => {
	/*
	 * When editing an input field in the table -> set the input as updated. 
	 * Sets an hidden input field (submit_row) to true so that when submitting the form it only sends rows that have been changed. (Resolves the issue with the limit of 2000 POST fields per request).
	 * Works only if given data-form="true" and a data-unique-id="id"
	 * https://examples.bootstrap-table.com/#methods/update-cell-by-unique-id.html#view-source
	 */
	if(table.data('form')){
		table.find('input').unbind('change.update-virtual-dom').bind('change.update-virtual-dom', function(){
			$(this).attr('data-changed', true);
			
			let hiddenSubmitRow = $(this).parents('tr').eq(0).find('input[name$="submit_row]"]');
			hiddenSubmitRow.val(1);
			hiddenSubmitRow.attr('data-changed', true);
		});

		//Show all field on submit
		table.parents('form').submit(function(e) {
			$('html').addClass('cursor-progress');

			let searchValue = $('.search-input').val();

			table.bootstrapTable('resetSearch') ;

			if(searchValue != ''){
				$('[data-id="search"]').val(searchValue);			
			}

			// Remove all rows that were not edited
			table.find('input[name$="submit_row]"][value="0"]').parents('tr').remove();
		});
	}
}

//Used only when loading the data via ajax
window.bootstrapTableEditFormatter = (value) => {
	return `<a
		href='`+value+`'
		class='btn btn-info btn-icon'
		style='background-image: url("/storage/img/edit.png")'></a>`;
}

//Used only when loading the data via ajax
window.bootstrapTableRowFormatter = (row) => {
	let classes = null;

	if(row.offline == 1){
		classes = 'offline';
	}

	if(row.warning == 1){
		classes = 'warning';
	}

	if(classes){
		return {
			classes: classes
		}
	}

	return {};
}


//Used to sort columns with a date
window.dateSorter = (a, b) => {	
	if(!a){
		a = '01.01.1970';
	}
	if(!b){
		b = '01.01.1970';
	}

	let split = a.split('.');
	a = split[2] + '-' + split[1] + '-' + split[0];
	split = b.split('.');
	b = split[2] + '-' + split[1] + '-' + split[0];

	if (new Date(a) < new Date(b)) return 1;
	if (new Date(a) > new Date(b)) return -1;
	return 0;
}

// Used to sort columns with a price
window.priceSorter = (a, b) => {
    a = a.replace('CHF', '');
    a = a.replace("'", '');
    a = a.replace("&#39;", '');

    b = b.replace('CHF', '');
    b = b.replace("'", '');
    b = b.replace("&#39;", '');

    return a - b
}

// Used to sort columns with a percentage
window.statisticsPercentageSorter = (a, b) => {
    a = a.replace('%', '');
    a = a.replace("'", '');
    a = a.replace("&#39;", '');
    a = a.replace('<span class="text-success">', '');
    a = a.replace('<span class="text-danger">', '');
    a = a.replace('</span>', '');

    b = b.replace('%', '');
    b = b.replace("'", '');
    b = b.replace("&#39;", '');
    b = b.replace('<span class="text-success">', '');
    b = b.replace('<span class="text-danger">', '');
    b = b.replace('</span>', '');
    
    return a - b
}

// Used to sort columns with numbers like offer number, order number etc.
window.numberSorter = (a, b) => {
    a = a.replace('-', '');
    a = a.replace('B', '');
    a = a.replace('A', '');

    b = b.replace('-', '');
    b = b.replace('B', '');
    b = b.replace('A', '');

    return a - b
}

// Used to sort columns with a price
window.priceSorterWithPercentage = (a, b) => {
    a = a.replace('CHF', '');
    a = a.replace("'", '');
    a = a.replace("&#39;", '');
    a = parseFloat(a);

    b = b.replace('CHF', '');
    b = b.replace("'", '');
    b = b.replace("&#39;", '');
    b = parseFloat(b);

    return a - b
}

// Used to sort columns with numbers like offer number, order number etc.
window.numberSorterWithPercentage = (a, b) => {
    a = a.replace('-', '');
    a = a.replace('B', '');
    a = a.replace('A', '');
    a = parseFloat(a);

    b = b.replace('-', '');
    b = b.replace('B', '');
    b = b.replace('A', '');
    b = parseFloat(b);

    return a - b
}

const initToolbar = table => {
	if($('form#toolbar').length){
		$('form#toolbar').find('input, select').change(function(){
			table.bootstrapTable('refresh');
		});
	}
}

const init = () =>{	
	$('.bootstrap-table').each(function() {
		let table = $(this);
		var classes = 'table table-hover ';
		if($(this).data('class')){			
			classes += $(this).data('class');
		}

		let tableOptions = {
			classes: classes
		};

		// Add Ajax options
		if($(this).data('side-pagination') == 'server'){
			tableOptions = {
				...tableOptions,
				ajax: function(params){
					let url = params.url;
					if(!url.includes('?')){
						url += '?';
					}					
					url += '&' + $.param(params.data);


					if($('form#toolbar').length){
						url += '&' + $('form#toolbar').serialize();
					}
					
					$.get({
						url: url,
						dataType: 'json',
					    beforeSend: function (xhr) {
							xhr.setRequestHeader('Authorization', 'Bearer ' + $('meta[name="api-token"]').attr('content'));
							xhr.setRequestHeader('lang', $('html').attr('lang'));
					    },
					    success: function (res) {
							params.success(res)
						}
					});
				}
			}
		}

		table.bootstrapTable(tableOptions)

		//Transform the table in a card view when reaches the breakpoint
		if(table.data('card-view-breakpoint')){
			$( window ).resize(function() {	
		  		if($(window).width() >= table.data('card-view-breakpoint') && table.bootstrapTable('getOptions').cardView){
		  			// Table view
					table.bootstrapTable('toggleView')
		  		}else if($(window).width() <= table.data('card-view-breakpoint') && !table.bootstrapTable('getOptions').cardView){
		  			// Card view
		  			table.bootstrapTable('toggleView')		  			
		  			table.find('.btn-icon').parents('.card-view').addClass('btn-container')
		  		}
			});

			$(window).trigger('resize');
		}

		updateVirtualDomAfter(table);

		//Functions to call after all the records are loaded -> after searching, after changing page and after loading via ajax
		table.on('post-body.bs.table', function() {
		    initDeleteBtn();
		    updateVirtualDomAfter(table);
		});

		//Functions to call before all the records are loaded -> before searching, before changing page and before loading via ajax
		table.on('pre-body.bs.table', function() {
			updateVirtualDomBefore(table);
		});

		initToolbar(table);
	});
}

export default init;